const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[~`!@#$%^&*()-_+={}[\]|;:"<>,./?]).{8,}$/;

export function checkPassFormat(myPass) {
  return passwordRegex.test(myPass);
}
